module.exports = __webpack_public_path__ + "img/w3_trash_recover_grey.470ecc5e.png";